import { useQuery } from 'react-query'
import { makeCoreGetRequest } from 'utils/api'
import { handleQueryError } from 'utils/helpers'

export const getVoucherInfo = (showNotification: Function, barcode: string) => {
  return useQuery(
    ['cora-voucher-info', barcode],
    async () => {
      const result = await makeCoreGetRequest(`/sgr/voucher/info?barcode=${barcode}`)

      return result
    },
    {
      onError: error =>
        handleQueryError(
          error,
          'A aparut o eroare la obtinerea datelor despre voucher.',
          showNotification
        ),
      enabled: false,
      staleTime: 200,
      cacheTime: 200,
      keepPreviousData: false
    }
  )
}
